"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const BaseModal = (props) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "base-modal", children: [(0, jsx_runtime_1.jsx)("div", { className: "base-modal--title", children: props.title }), (0, jsx_runtime_1.jsx)("div", { className: "base-modal--content", children: props.content }), (0, jsx_runtime_1.jsx)("div", { className: "base-modal-actions", children: (0, jsx_runtime_1.jsx)("button", { onClick: (input) => props.onClose && props.onClose(), children: "Schlie\u00DFen / close" }) })] }) }));
};
exports.BaseModal = BaseModal;
